if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
  document.querySelectorAll('.card-product__swatch-list .swatch[data-swatch-image]').forEach((swatch) => {
    const card = swatch.closest('.card-wrapper');
    const media = card && card.querySelector('.card__media');
    const images = media ? media.querySelectorAll('img') : [];
    const image = images[0];
    const secondaryImage = images[1];
    if (!image) return;

    swatch.addEventListener('mouseenter', () => {
      if (!image.dataset.originalSrc) {
        image.dataset.originalSrc = image.src;
        image.dataset.originalSrcset = image.srcset;
      }
      image.srcset = '';
      image.src = swatch.dataset.swatchImage;
      // Override Dawn's card-hover crossfade (component-card.css), which
      // would otherwise fade in the unrelated secondary photo while the
      // swatch (a child of .card-wrapper) is hovered.
      image.style.opacity = '1';
      if (secondaryImage) secondaryImage.style.opacity = '0';
    });

    swatch.addEventListener('mouseleave', () => {
      if (!image.dataset.originalSrc) return;
      image.src = image.dataset.originalSrc;
      image.srcset = image.dataset.originalSrcset;
      image.style.opacity = '';
      if (secondaryImage) secondaryImage.style.opacity = '';
    });
  });
}
